import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { SharingCatalogKey } from './sharing.i18n.js';
import { SHARING_CATALOG } from './sharing.i18n.js';

export type SharingMessageId = `sharing:${SharingCatalogKey}`;

const PREFIX_LENGTH = 'sharing:'.length;

/** `t()` for the stop-gap `sharing:` scope (see `sharing.i18n.ts`). */
export function useSharingT(): { t: (id: SharingMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: SharingMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as SharingCatalogKey;
      const raw = SHARING_CATALOG[locale][key] ?? SHARING_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
